import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { ClinicConfigState, ClinicConfig } from './ClinicConfig.types'

const useClinicConfigStore = create<ClinicConfigState>()(
  persist(
    set => ({
      clinic: { flag: {} },
      updateValue: (_: string, value: ClinicConfig) => {
        set({ clinic: value })
      },
    }),
    {
      name: '@Conexa:clinic-config',
    },
  ),
)

export default useClinicConfigStore
